import React from "react";
import { DatesAndGuests } from "../components/common/start-widget/widget-form/WidgetForm";
import Quote from "../Data/Quote/Quote";
import StartWidget, { StartWidgetDefaults } from "../Data/StartWidget";
import WidgetStyle, { WidgetStyleDefaults } from "../Data/WidgetStyle";
import { Constants } from "../_helpers/Constants";
import StartWidgetBrandSetting from "../Data/StartWidgetBrandSetting";
import StartWidgetBrand from "../Data/StartWidgetBrand";

interface ContextProps {
  companyId: number | undefined;
  // brandId: number | undefined;
  brandSettings: StartWidgetBrandSetting[];
  startWidget: StartWidget;
  style: WidgetStyle;
  datesAndGuests: DatesAndGuests;
  fromEmail: boolean;
  viewPortWidth: number;
  viewPortHeight: number;
  viewPortBreakPoint: number;
  autoScroll: boolean;
  vendorGuid: string | undefined;
  campaignId: string | undefined;
  brand: StartWidgetBrand | undefined;
}

export const WidgetContext = React.createContext<ContextProps>({
  companyId: undefined,
  // brandId: undefined,
  brandSettings: [],
  startWidget: StartWidgetDefaults,
  style: WidgetStyleDefaults,
  datesAndGuests: {
    fromDate: Constants.startingDate,
    toDate: Constants.threeDaysFromStartingDate,
    guests: 2,
    units: 1
  },
  fromEmail: false,
  viewPortWidth: 0,
  viewPortHeight: 0,
  viewPortBreakPoint: 0,
  brand: undefined,
  autoScroll: true,
  vendorGuid: undefined,
  campaignId: undefined
});